<template>

    <div class="hamburger d-md-none">
        <button
            id="hamburger-toggle"
            type="button"
            :aria-label="showMobileMenu ? $t('labels.close') : $t('labels.menu')"
            :aria-expanded="showMobileMenu ? 'true' : 'false'"
            aria-controls="hamburger-menu"
            @click="toggle"
        >
            <i :class="showMobileMenu ? 'fas fa-times' : 'fas fa-bars'" aria-hidden="true"></i>
        </button>

        <transition name="hamburger-backdrop">
            <div
                v-if="showMobileMenu"
                class="hamburger-backdrop"
                aria-hidden="true"
                @click="close"
            />
        </transition>

        <transition name="hamburger-sheet">
            <div
                v-if="showMobileMenu"
                id="hamburger-menu"
                class="hamburger-sheet"
                role="navigation"
                :aria-label="$t('labels.menu')"
            >
                <nav class="hamburger-nav" @click="onNavClick">
                    <slot />
                </nav>
            </div>
        </transition>
    </div>

</template>

<style lang="scss">

    .hamburger {
        position: relative;
    }

    #hamburger-toggle {
        @include font-semibold(16px);
        align-items: center;
        appearance: none;
        background: none;
        border: none;
        color: $color-text;
        cursor: pointer;
        display: flex;
        height: 40px;
        justify-content: center;
        margin: 0;
        padding: 0;
        position: relative;
        transition: color .3s;
        width: 30px;
        z-index: 101;
        &:hover {
            color: $color-primary;
        }
    }

    .hamburger-backdrop {
        background: rgba(15, 23, 42, 0.35);
        bottom: 0;
        left: 0;
        position: fixed;
        right: 0;
        top: 60px;
        z-index: 98;
    }

    .hamburger-sheet {
        background: $color-white;
        border-bottom: 1px solid $color-rule-light;
        box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
        left: 0;
        position: fixed;
        right: 0;
        top: 60px;
        width: 100%;
        z-index: 99;
    }

    .hamburger-nav {
        display: flex;
        flex-direction: column;
        padding: 8px 0;
        .dropdown-item {
            @include font-medium(15px);
            align-items: center;
            background: none;
            border-bottom: 1px solid $color-rule-light;
            color: $color-text;
            display: flex;
            gap: 12px;
            min-height: 48px;
            padding: 0 20px;
            text-decoration: none;
            transition: background-color .2s, color .2s;
            user-select: none;
            i {
                color: $color-primary;
                flex: 0 0 auto;
                font-size: 15px;
                text-align: center;
                width: 18px;
            }
            &:last-child {
                border-bottom: none;
            }
            &:hover, &:active {
                background: $color-primary-light;
                color: $color-primary;
                text-decoration: none;
            }
        }
    }

    .hamburger-backdrop-enter-active {
        transition: opacity .28s ease;
    }
    .hamburger-backdrop-leave-active {
        transition: opacity .2s ease;
    }
    .hamburger-backdrop-enter,
    .hamburger-backdrop-leave-to {
        opacity: 0;
    }

    .hamburger-sheet-enter-active {
        transition: opacity .28s cubic-bezier(0.22, 1, 0.36, 1), transform .28s cubic-bezier(0.22, 1, 0.36, 1);
    }
    .hamburger-sheet-leave-active {
        transition: opacity .2s ease, transform .2s ease;
    }
    .hamburger-sheet-enter,
    .hamburger-sheet-leave-to {
        opacity: 0;
        transform: translateY(-8px);
    }

</style>

<script>

export default {

    data() {
        return {
            showMobileMenu: false,
        };
    },

    watch: {
        showMobileMenu(open) {
            document.body.style.overflow = open ? 'hidden' : '';
        },
        '$route'() {
            this.close();
        },
    },

    beforeDestroy() {
        document.body.style.overflow = '';
    },

    methods: {
        toggle() {
            this.showMobileMenu = !this.showMobileMenu;
        },
        close() {
            this.showMobileMenu = false;
        },
        onNavClick(event) {
            const link = event.target.closest('a');
            if (link) {
                this.close();
            }
        },
    },

}

</script>
